import React, { useState } from "react";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";
import "./highlights-trust.css";
import HighlightLine from "./highlights-line";
import { FaCaretRight } from "react-icons/fa6";

export default function HighlightsTrust() {
  const [counterOn, setCounterOn] = useState(false);

  return (
    <div>
      <ScrollTrigger
        onEnter={() => setCounterOn(true)}
        onExit={() => setCounterOn(false)}
      >
        <div className="r-part">
          <div className="values-loader">
            <span style={{ color: "#3CE5B2" }}>+</span>
            {counterOn && (
              <CountUp start={0} end={82} decimals={0} duration={2} delay={0} />
            )}
            % <span className="empower-circle1">E10</span>
            <div 
              className="hover-area-home-page hover-area-home-page-empower-01"
            >
              <p className="tooltip-texts-home-page">Zero Waste to Landfill</p>
              <FaCaretRight size={30} className="hover-area-arrow-home-page" />
            </div>
          </div>
          <p className="values-para">
            of the Group involved in Wonders of Wellbeing program
          </p>
          <p className="values-loader">
            <span style={{ color: "#3CE5B2" }}>+</span>
            {counterOn && (
              <CountUp
                start={0}
                end={104}
                decimals={0}
                duration={2}
                delay={0}
              />
            )}
            % <span className="empower-circle2">E8</span>
            <div 
              className="hover-area-home-page hover-area-home-page-empower-02"
            >
              <p className="tooltip-texts-home-page">Harvest Minimum 10% of Domestic Water from Rainwater</p>
              <FaCaretRight size={30} className="hover-area-arrow-home-page" />
            </div>
          </p>
          <p className="values-para">
            Exceeding target for 80% of supervisors to be reached via
            development programs
          </p>
          <p className="values-loader">
            <span style={{ color: "#3CE5B2" }}>+</span>
            {counterOn && (
              <CountUp
                start={0}
                end={100}
                decimals={0}
                duration={2}
                delay={0}
              />
            )}
            % <span className="empower-circle3">E7</span>
            <div 
              className="hover-area-home-page hover-area-home-page-empower-03"
            >
              <p className="tooltip-texts-home-page">Recycle over 50% of Industrial Wastewater for Industrial Processes</p>
              <FaCaretRight size={30} className="hover-area-arrow-home-page" />
            </div>
          </p>
          <p className="values-para">
            of facilities rated on FSLM, SLCP of equivalent audits
          </p>

          <div className="horizontal-line" />
          <div style={{ paddingBottom: "120px" }} />
        </div>
        <HighlightLine />
        <div style={{ paddingBottom: "1px" }} />
        <div className="mobile">
          <div style={{ paddingBottom: "10px" }} />
        </div>
      </ScrollTrigger>
    </div>
  );
}
